// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--EmDNO","body":"_9e1425b4d3--body--QdzGX","sidebar":"_9e1425b4d3--sidebar--T4tz_"};